<template>
  <div
    v-if="
      dataPermission.includes('SCON_RECEIPT_AGENCY_UPDATE') ||
      dataPermission.includes('SCON_RECEIPT_AGENCY_ADD')
    "
  >
    <div class="breadcrumb-area pos-relative w-100">
      <h1>
        {{ idUpdate ? `Cập nhật phiếu thu đối tác` : 'Tạo phiếu thu đối tác' }}
      </h1>
      <div class="float-right btn-group">
        <button type="button" class="font-medium btn btn-outline-secondary" @click="requestItem()">
          {{ idUpdate ? 'Cập nhật' : 'Tạo mới' }}
        </button>
        <button
          type="button"
          class="font-medium btn btn-outline-secondary"
          @click="$router.push('/agent-receipt')"
        >
          <i class="bx bx-exit"></i> Hủy bỏ
        </button>
      </div>
    </div>
    <div class="p-10 card pt-15 b-t-1-869fb229">
      <ValidationObserver ref="inventoryRef" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(requestItem)">
          <div class="px-20 mt-2 card-body row">
            <div class="col-md-6">
              <ValidationProvider rules="required" vid="agencyCode" name="Tên đại lý">
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label">
                    Tên đại lý <span style="color: red">*</span>
                  </label>
                  <div class="col-sm-7">
                    <Select2
                      placeholder="Tìm kiếm/Chọn đại lý"
                      v-model="dataAdd.agencyCode"
                      :options="optionAgency"
                      :disabled="!!idUpdate"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required" vid="appendixCode" name="Mã phụ lục">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for class="col-sm-3 col-form-label"
                    >Mã phụ lục <span style="color: red">*</span></label
                  >
                  <div class="col-sm-7">
                    <input
                      v-model.trim="dataAdd.appendixCode"
                      type="text"
                      class="form-control"
                      placeholder="*** *** ***"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required" vid="price" name="Số tiền">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for class="col-sm-3 col-form-label"
                    >Số tiền <span style="color: red">*</span></label
                  >
                  <div class="col-sm-7">
                    <input
                      v-model.trim="dataAdd.amount"
                      type="number"
                      :min="0"
                      class="form-control"
                      placeholder="Vi dụ: 10.000 VNĐ"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <div class="form-group row">
                <label class="col-sm-3 col-form-label">Mã giao dịch </label>
                <div class="col-sm-7">
                  <input
                    v-model.trim="dataAdd.transactionCode"
                    type="text"
                    class="form-control"
                    placeholder="*** *** ***"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-3 col-form-label"> Ngày thu tiền </label>
                <div class="col-sm-7">
                  <datepicker
                    format="dd/MM/yyyy"
                    :language="vi"
                    v-model="dataAdd.receiptDate"
                    placeholder="Chọn ngày thu tiền"
                  ></datepicker>
                </div>
              </div>
              <div class="form-group row">
                <label for class="col-sm-3 col-form-label">Ghi chú</label>
                <div class="col-sm-7">
                  <textarea
                    v-model.trim="dataAdd.description"
                    type="text"
                    class="form-control"
                    placeholder="Ghi chú"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <!-- :disabled="!canEdit" -->

              <UploadOneOrMultip
                :title="'Ảnh chuyển khoản'"
                :maxFile="100"
                titleTag="h2"
                :uploadToApi="false"
                :isDragging="true"
                titleClass="form-inner-heading"
                ref="uploadComponent"
              />
            </div>
          </div>
          <div class="mx-5 card-body">
            <div class="p-0 pt-2 card">
              <div
                class="mb-2 d-flex pos-relative w-100 justify-content-between align-items-baseline flex-wrap"
              >
                <h1 class="mb-1 form-inner-heading">Danh sách thiết bị</h1>
                <div class="float-right btn-group">
                  <button
                    type="button"
                    @click="deleteDeviceMul"
                    v-if="selected.length > 0"
                    class="font-medium f12 btn btn-outline-secondary"
                  >
                    <i class="bx bx-minus-circle"></i> Xoá
                  </button>
                  <button
                    type="button"
                    @click="exportTemplateTransferWarehouse"
                    class="font-medium f12 btn btn-outline-secondary"
                  >
                    <i class="bx bx-download"></i> Tải file mẫu
                  </button>
                  <button
                    type="button"
                    @click="$refs.uploadFileExcel.click()"
                    class="font-medium f12 btn btn-outline-secondary"
                  >
                    <i class="bx bx-upload"></i> import file
                  </button>
                  <button
                    type="button"
                    @click="showAddDevice"
                    class="font-medium f12 btn btn-outline-secondary"
                  >
                    <i class="bx bxs-plus-circle"></i> Chọn thiết bị
                  </button>
                  <input
                    style="display: none"
                    ref="uploadFileExcel"
                    @change="uploadFileExcel"
                    type="file"
                  />
                </div>
              </div>
              <div class="tab-content">
                <div
                  class="table-responsive b-table-sticky-header"
                  style="overflow: auto; max-height: 70vh"
                >
                  <table class="table table-hover table-bordered">
                    <thead class="thead-light">
                      <tr class="text-center">
                        <th>
                          <input type="checkbox" v-model="selectAll" />
                        </th>
                        <th class="text-left">Tên loại thiết bị</th>
                        <th>Mã Serial</th>
                        <th>Thao tác</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        class="table-row text-center"
                        v-for="(device, index) in dataAdd.devices"
                        :key="`device${index}`"
                      >
                        <td>
                          <input type="checkbox" v-model="selected" :value="device" />
                        </td>
                        <td class="text-left">
                          {{ device.text ? device.text : device.categoryName }}
                        </td>
                        <td>{{ device.serial }}</td>
                        <td>
                          <b-button
                            type="button"
                            size="md"
                            variant="danger"
                            @click="deleteDevice(index)"
                          >
                            Xoá
                          </b-button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <button type="submit" v-show="false"></button>
          </div>
        </form>
      </ValidationObserver>
    </div>
    <div v-if="showModalNoti">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Thông báo</h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    @click="showModalNoti = false"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="text-center modal-body">
                  <img :src="srcImage" alt="icon-successs" />
                  <h2 class="py-3 f18">{{ messNoti }}</h2>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="$router.push('/agent-receipt')"
                    data-dismiss="modal"
                    v-if="keyCheck === 'accept' || keyCheck === 'back' || keyCheck === 'addLead'"
                  >
                    Đồng ý
                  </button>
                  <button
                    type="button"
                    class="btn btn-light"
                    @click="showModalNoti = false"
                    data-dismiss="modal"
                    v-if="keyCheck === 'cancel' || keyCheck === 'back'"
                  >
                    Đóng
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <b-modal
      id="modal-noti"
      centered
      v-model="modalChooseDevice"
      ignore-enforce-focus-selector="input"
    >
      <template #modal-header="{ close }">
        <h5>Chọn thiết bị</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          @click="close()"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <form @submit.prevent="filterDevice" class="box-search">
        <div class="form-group">
          <Select2
            placeholder="Loại thiết bị"
            v-model="searchDevice.text"
            :options="deviceCatData"
          />
        </div>
        <div class="form-group" v-if="isAll === true">
          <input
            v-model.trim="searchDevice.numberGear"
            type="text"
            class="form-control"
            placeholder="Số thùng"
          />
        </div>
        <div class="form-group">
          <input
            v-model.trim="searchDevice.serial"
            type="text"
            class="form-control"
            placeholder="Mã serial"
          />
        </div>
        <div class="form-group form-group-action d-flex" style="gap: 5px">
          <button type="submit" class="font-medium btn btn-outline-secondary" @click="filterDevice">
            Lọc
          </button>
          <button
            type="buton"
            @click="unFilterDevice"
            class="font-medium btn btn-outline-secondary"
          >
            Bỏ lọc
          </button>
        </div>
      </form>
      <div class="table-responsive b-table-sticky-header">
        <div style="max-height: 400px; overflow: auto">
          <table class="table table-hover table-bordered">
            <thead class="thead-light">
              <tr class="text-center">
                <th>
                  <input type="checkbox" v-model="selectAllDevice" />
                </th>
                <th>Loại thiết bị</th>
                <th>Mã Serial</th>
                <th>DVT</th>
                <th>Tình trạng</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="table-row text-center"
                v-for="(device, index) in dataMaterial || []"
                :key="`dataMaterial${index}`"
              >
                <td>
                  <input id="checkbox" type="checkbox" v-model="selectedDevice" :value="device" />
                </td>
                <td class="text-left">{{ device.text }}</td>
                <td>{{ device.serial }}</td>
                <td>{{ device.unit | transformData(Config.unitDevice) }}</td>
                <td>
                  <span class="badge" :class="[device.type || '']">
                    {{ device.type | transformData(Config.stateDevices) }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button @click="requestDevice" size="md" variant="primary"> Thêm </b-button>
        <b-button size="md" variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>
    <VueLoadingOverlay :active.sync="loading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { DeviceService } from '@/services/device.service'
  import { vi } from 'vuejs-datepicker/dist/locale'
  import cloneDeep from 'lodash/cloneDeep'
  import differenceBy from 'lodash/differenceBy'
  import Config from '../../../thirdParty/config'
  import UploadOneOrMultip from '@/components/cskh/UploadOneOrMultip.vue'
  import { nextTick } from 'vue'
  export default {
    name: 'add-transfer-warehouse',
    data() {
      return {
        Config,
        idUpdate: this.$route.params.entryId || '',
        createdDate: new Date().getTime(),
        dataAdd: {
          // dateCreate: new Date().getTime(),
          // dateTransfer: new Date().getTime(),
          dateTransfer: '',
          reasonTransfer: '',
          devices: [],
        },
        dataUser: JSON.parse(localStorage.getItem('userData')),
        loading: false,
        showModalNoti: false,
        keyCheck: 'cancel',
        messNoti: '',
        srcImage: '',
        vi: vi,
        selected: [],
        selectedDevice: [],
        modalChooseDevice: false,
        warehouseUserActiveData: [],
        warehouseActive: [],
        warehouseActiveData: [],
        deviceData: [],
        deviceFilterData: [],
        deviceCatData: [],
        currentStep: 1,
        searchDevice: {},
        isAll: false,
        hintReasonTransfer: null,
        dataMaterial: [],
        dataFilter: [],
        dateCreate: '',
        optionAgency: [],
      }
    },
    filters: {
      transformData(data, dataConfig) {
        const dataReturn = dataConfig.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].text
      },
    },
    components: {
      UploadOneOrMultip,
    },
    async created() {
      this.fetchCatDevice()
      await this.fetchAgencyData()
      if (this.idUpdate) {
        this.getDetail()
      }
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      selectAll: {
        get: function () {
          return this.dataAdd.devices ? this.selected.length === this.dataAdd.devices.length : false
        },
        set: function (value) {
          if (value) {
            this.selected = cloneDeep(this.dataAdd.devices)
          } else this.selected = []
        },
      },
      selectAllDevice: {
        get: function () {
          return this.dataMaterial ? this.selectedDevice.length === this.dataMaterial.length : false
        },
        set: function (value) {
          if (value) {
            this.selectedDevice = cloneDeep(this.dataMaterial)
          } else this.selectedDevice = []
        },
      },
    },

    methods: {
      async fetchAgencyData() {
        // AI
        this.loading = true // AI
        try {
          // AI
          // First API call with limit 20 // AI
          const response = await DeviceService.getListAgency({
            // AI
            limit: 20, // AI
            page: 1, // AI
            keeperId: this.dataUser?.userId || '', // AI
            sort: {
              // AI
              direction: 'DESC', // AI
              properties: ['createdDate'], // AI
            }, // AI
          }) // AI

          // Set options with the first batch of data // AI
          this.optionAgency = // AI
            response.data?.map(item => {
              // AI
              return {
                // AI
                id: item?.code,
                text: item?.name || '',
              } // AI
            }) || [] // AI

          // Check if total is greater than limit (20) // AI
          if (response.paging && response.paging.total > response.paging.limit) {
            // AI
            // Make a second API call to get all records // AI
            const fullResponse = await DeviceService.getListAgency({
              // AI
              limit: response.paging.total, // AI
              page: 1, // AI
              keeperId: this.dataUser?.userId || '', // AI
              sort: {
                // AI
                direction: 'DESC', // AI
                properties: ['createdDate'], // AI
              }, // AI
            }) // AI

            // Update options with all agency data // AI
            this.optionAgency = // AI
              fullResponse.data?.map(item => {
                // AI
                return {
                  // AI
                  id: item?.code, // AI
                  text: item?.name || '', // AI
                } // AI
              }) || [] // AI
          } // AI
        } catch (error) {
          console.error('Error fetching agency data:', error)
        } finally {
          this.loading = false
        }
      },

      async getDetail() {
        this.loading = true
        try {
          const res = await DeviceService.detailTransferAgencyNew(this.idUpdate)
          if (res.code === 1000) {
            this.optionAgency = [
              {
                id: res.data?.agencyCode,
                text: res.data?.agencyName,
              },
            ]

            this.dataAdd = res.data || {}

            if (this.dataAdd.receiptDate)
              this.dataAdd.receiptDate = new Date(this.dataAdd.receiptDate)

            this.dataAdd.devices = res.data.devices.map(item => {
              return {
                ...item,
                id: item.serial,
                text: item.name,
              }
            })

            const formattedImages = res.data.uploadImgs.map(imgUrl => ({
              url: imgUrl,
              location: 'website',
              type: 'images',
              uploaded: true,
            }))

            nextTick(() => {
              this.$refs.uploadComponent.setData(formattedImages)
            })
          }
        } catch (error) {
          console.error(error)
        } finally {
          this.loading = false
        }
      },

      async fetchCatDevice() {
        const response = await DeviceService.typeDeviceConfig()
        this.deviceCatData = response.data.map(({ name }) => {
          return { id: name, text: name }
        })
      },
      async fetchDeviceByInventory() {
        this.loading = true
        const response = await DeviceService.listDeviceAgent()
        this.deviceFilterData = response.data
        this.dataMaterial = response.data.map(item => {
          return {
            id: item.id,
            text: item.categoryName,
            serial: item.serial,
            type: item.type,
            unit: item.unit,
          }
        })
        this.dataFilter = this.dataMaterial
        this.loading = false
      },
      unFilterDevice() {
        this.searchDevice = {}
        this.fetchDeviceByInventory()
      },
      async filterDevice() {
        const deviceData = this.dataFilter.filter(s => {
          const rules = []
          if (this.searchDevice.serial) {
            rules.push(s.serial.toLowerCase().indexOf(this.searchDevice.serial.toLowerCase()) > -1)
          }
          if (this.searchDevice.numberGear) {
            rules.push(
              s.numberGear.toLowerCase().indexOf(this.searchDevice.numberGear.toLowerCase()) > -1
            )
          }
          if (this.searchDevice.text) {
            rules.push(s.text === this.searchDevice.text)
          }
          return !rules.includes(false)
        })
        this.dataMaterial = deviceData
      },
      async requestItem() {
        const isSuccess = await this.$refs.inventoryRef.validate()
        if (!isSuccess) {
          return
        }
        if (this.dataAdd.devices.length === 0) {
          this.showErr('Danh sách thiết bị không được bỏ trống')
          return
        }
        try {
          this.loading = true
          const params = cloneDeep(this.dataAdd)
          const explanationImage = await this.$refs.uploadComponent.saveData()
          params.receiptDate = new Date(params.receiptDate).getTime()
          params.uploadImgs = explanationImage.map(item => item.urlImage) || []
          params.devices =
            params.devices?.map(({ serial, text }) => ({
              name: text || '',
              serial: serial || '',
            })) || []

          let response = {}

          if (this.idUpdate) {
            params.id = this.idUpdate
            delete params.agencyCode
            delete params.agencyName
            delete params.regionId
            delete params.mobile
            delete params.fullTextSearch
            delete params.email
            delete params.saleIdViewers
            delete params.serials
            delete params.address
            delete params.createdBy
            delete params.createdDate
            delete params.status

            response = await DeviceService.updateTransferAgencys(params)
          } else {
            response = await DeviceService.createTransferAgencys(params)
          }
          if (response.code === 1000) {
            this.keyCheck = 'accept'
            this.showSuccess(
              this.idUpdate
                ? 'Cập nhật phiếu thu đại lý thành công !'
                : 'Thêm phiếu thu đại lý thành công !'
            )
          } else {
            this.keyCheck = 'cancel'
            this.showErr(response.message)
          }
        } catch (error) {
          this.showErr(error.message)
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      showErr(message) {
        this.showModalNoti = true
        this.messNoti = message
        this.srcImage = require('@/assets/img/noti-unsuccess2.svg')
      },
      showSuccess(message) {
        this.showModalNoti = true
        this.messNoti = message
        this.srcImage = require('@/assets/img/noti-success2.svg')
      },
      deleteDevice(index) {
        const h = this.$createElement
        const messageVNode = h('p', {
          domProps: {
            innerHTML: 'Bạn chắc chắn xoá thiết bị trên!',
          },
        })
        this.$bvModal
          .msgBoxConfirm([messageVNode], {
            title: 'Xoá thiết bị',
            okTitle: 'Xoá',
            cancelTitle: 'Huỷ',
            centered: true,
          })
          .then(value => {
            if (value) {
              this.dataAdd.devices.splice(index, 1)
            }
          })
      },
      deleteDeviceMul() {
        const h = this.$createElement
        const messageVNode = h('p', {
          domProps: {
            innerHTML: 'Bạn chắc chắn xoá những thiết bị đã được chọn trên!',
          },
        })
        this.$bvModal
          .msgBoxConfirm([messageVNode], {
            title: 'Xoá thiết bị',
            okTitle: 'Xoá',
            cancelTitle: 'Huỷ',
            centered: true,
          })
          .then(value => {
            if (value) {
              this.dataAdd.devices = differenceBy(this.dataAdd.devices, this.selected, 'id')
              this.selected = []
            }
          })
      },
      async requestDevice() {
        const arr = [...this.selectedDevice, ...this.dataAdd.devices]
        this.dataAdd.devices = this.getUnique(arr, 'id')
        this.modalChooseDevice = false
        this.selectedDevice = []
      },
      async exportTemplateTransferWarehouse() {
        try {
          this.loading = true
          await DeviceService.exportTemplateTransferAgent()
        } finally {
          this.loading = false
        }
      },
      async dowloadFileError(reqs) {
        try {
          this.loading = true
          await DeviceService.exportDeviceExcelTransferAgent(reqs)
        } finally {
          this.loading = false
        }
      },
      async uploadFileExcel(file) {
        if (file.target.files.length === 0) return
        const allowedExtensions = /(\.xls|\.xlsx|\.csv|\.ods)$/i
        const checkFomat = allowedExtensions.exec(file.target.files[0].name)
        if (!checkFomat) {
          this.showErr('Định dạng không hợp lệ !')
          this.$refs.uploadFileExcel.value = null
          return
        }
        const formdata = new FormData()
        formdata.append('file', file.target.files[0])
        console.log('file', file)
        try {
          this.loading = true
          const res = await DeviceService.importDeviceExcelTransferAgent(formdata)
          if (res.code === 1000) {
            const arr = [...res.data.correctList, ...this.dataAdd.devices]
            this.dataAdd.devices = this.getUnique(arr, 'id')
            this.showMsgOk(res.data)
          } else if (res.code === 1020 || res.code === 1007) {
            this.showErr(
              'Thông tin trong file không đúng quy định hoặc dung lượng file quá lớn (tối đa 25MB)'
            )
          } else if (res.code === 1021 || res.code === 1040) {
            this.showErr(res.res[0].message)
          } else {
            this.showErr(res.message)
          }
        } catch (e) {
          this.showErr(
            'Thông tin trong file không đúng quy định hoặc dung lượng file quá lớn (tối đa 25MB)'
          )
          console.log('e', e)
        } finally {
          this.$refs.uploadFileExcel.value = null
          this.loading = false
        }
      },
      showMsgOk(data) {
        const h = this.$createElement
        // Using HTML string
        const titleVNode = h('div', {
          domProps: { innerHTML: 'Import file thành công' },
        })
        // More complex structure
        const messageVNode = h('div', { class: ['text-center'] }, [
          h('p', { class: ['text-center'] }, [
            'Số bản ghi thành công ',
            h('b', data.correctList.length),
            ' bản ghi',
          ]),
          h('p', { class: ['text-center'] }, [
            'Số bản ghi thất bại ',
            h('b', data.errorList.length),
            ' bản ghi',
          ]),
          data.errorList.length > 0 &&
            h(
              'button',
              {
                class: 'f12 font-medium btn btn-outline-danger',
                on: {
                  click: () => this.dowloadFileError(data.errorList),
                },
              },
              'Tải bản ghi thất bại'
            ),
        ])
        this.$bvModal.msgBoxOk([messageVNode], {
          title: [titleVNode],
          centered: true,
        })
      },
      getUnique(arr, comp) {
        const unique = arr
          .map(e => e[comp])
          .map((e, i, final) => final.indexOf(e) === i && i)
          .filter(e => arr[e])
          .map(e => arr[e])

        return unique
      },
      updateStatus(data) {
        this.dataAdd.devices.push(data)
        this.$bvModal.hide('add-material')
      },

      showAddDevice() {
        // this.modalChooseDevice = true
        this.fetchDeviceByInventory()
        this.$nextTick(() => {
          this.$bvModal.show('modal-noti')
        })
      },
      async fetchDevice(kind) {
        try {
          this.loading = true
          const params = {
            kind: kind,
            inventoryIds: [this.dataAdd.inventoryIdExport],
          }
          const response = await DeviceService.listDevice(params)
          this.dataMaterial = response.data.devices.map(item => {
            return {
              id: item.id,
              text: item.categoryName,
              serial: item.serial,
              type: item.type,
              unit: item.unit,
            }
          })
          this.dataFilter = this.dataMaterial
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      // formatTimestamp(timestamp) {
      //   const date = new Date(timestamp)
      //   const formattedDate = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`
      //   return formattedDate
      // }
    },
  }
</script>

<style scoped>
  .placeholder {
    background: #f0f0f0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #333;
    font-size: 18px;
    font-family: Helvetica;
  }

  .placeholder:hover {
    background: #e0e0e0;
  }
  .form-control-label {
    display: flex !important;
    align-items: center !important;
  }
  #checkbox {
    min-height: 13px;
    min-width: 13px;
  }
</style>
